import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {
  Label,
  InputGroup,
  Input,
  Button
} from 'reactstrap'
import moment from 'moment'
import 'moment/locale/de';
import Calendar from 'rc-calendar'
import DatePicker from 'rc-calendar/lib/Picker'
import 'rc-calendar/assets/index.css'
import deDE from 'rc-calendar/lib/locale/de_DE'

class FieldDate extends Component {
  constructor(props) {
    super(props)

    moment.locale('de')

    this.state = {
      open: false,
      date: props.cardField.fieldValue ?
            moment(props.cardField.fieldValue, 'YYYY-MM-DD').format('YYYY-MM-DD') : null
    }

    this.clearValue = this.clearValue.bind(this)
    this.toggleCalendar = this.toggleCalendar.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.returnValue = this.returnValue.bind(this)
  }

  toggleCalendar(ev) {
    ev && ev.preventDefault && ev.preventDefault()

    this.setState(prevState => {
      return {
        open: !prevState.open
      }
    })
  }

  clearValue(ev) {
    ev.preventDefault()

    this.setState({
      open: false,
      date: null
    })
  }

  handleDateChange(momentObj) {
    this.setState({
      date: momentObj ? momentObj.format('YYYY-MM-DD') : null
    })
  }

  returnValue() {
    return this.state.date
  }

  render() {
    function disabledDate(current) {
      if (!current) {
        return false
      }
      const date = moment()
      date.hour(0)
      date.minute(0)
      date.second(0)

      current.hour(0)
      current.minute(0)
      current.second(1)

      return current.valueOf() < date.valueOf()  // can not select days before today
    }

    const fieldClassName = `card-field field-datetime ${this.props.cardField.fieldClassName ? this.props.cardField.fieldClassName : ''}`

    const datePickerFooter = () => {
      return <div className="date-picker-footer px-2 text-right">
        <Button color="primary" onClick={this.toggleCalendar}>Ok</Button>
        <Button color="danger" outline className="float-left" onClick={this.clearValue}><i className="icon-trash"></i></Button>
      </div>
    }

    return this.props.isEditing || this.props.cardType === 'always-on' ? <div className={fieldClassName}>
      <Label for={this.props.cardField.id}>{this.props.cardField.fieldLabel}</Label>
      {this.state.open ? <Calendar
        locale={deDE}
        className="mb-3"
        showDateInput={false}
        format={'YYYY-MM-DD'}
        showOk={false}
        disabledDate={disabledDate}
        onChange={momentObj => { this.handleDateChange(momentObj) }}
        onPanelChange={(date, mode) => { date.locale('de') }}
        value={this.state.date ? moment(this.state.date, 'YYYY-MM-DD') : null}
        defaultValue={this.state.date ? moment(this.state.date, 'YYYY-MM-DD') : null}
        renderFooter={datePickerFooter}
      /> : <div>
        <span className="rc-time-picker mb-3">
          <input type="text" defaultValue={this.state.date} onClick={this.toggleCalendar} className="rc-time-picker-input" />
        </span>
        {' '}<i className="icon-calendar" onClick={this.toggleCalendar}></i>
      </div>
    }
    </div> : <div className={fieldClassName}>
      <Label className="mb-0" for={this.props.cardField.id}>{this.props.cardField.fieldLabel}</Label>
      <div className="mb-3">{this.props.cardField.fieldValue !== 'null' && this.props.cardField.fieldValue !== null ? moment(this.props.cardField.fieldValue, 'YYYY-MM-DD').format('LL') : null}</div>
    </div>
  }
}

FieldDate.propTypes = {
  cardField: PropTypes.object,
  isEditing: PropTypes.bool,
  cardType: PropTypes.string
}

FieldDate.defaultProps = {
  cardField: {
    cardSublabel: ''
  }
}

export default FieldDate


// WEBPACK FOOTER //
// ./src/components/EditableCard/FieldDate.js